import { Component, createPlatform, OnInit, OnDestroy } from "@angular/core";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SelectItem } from "primeng/api";
import { IssoUtilService } from "src/app/services/isso-util.service";
import { ReportMeritService } from "../service/report-merit.service";
import { MessageService } from "primeng/api";
import { PaymentInvoiceService } from "../service/payment-invoice.service";

@Component({
  selector: "app-admin-payment",
  templateUrl: "./admin-payment.component.html",
  styleUrls: ["./admin-payment.component.css"],
})
export class AdminPayment implements OnDestroy, OnInit {
  private destroy$ = new Subject<void>();
  date: Date[];
  yearOptions: SelectItem[];
  monthOptions: SelectItem[];
  isConsolited: boolean;
  reportValue: any;
  reportLabel: string;
  yearvalue: any;
  isDataAvailble: boolean;
  paymentData: any;
  allPaymentData: any[] = [];
  statusFilter = 'all';
  statusOptions = [
    { label: 'All statuses', value: 'all' },
    { label: 'Paid',        value: 'paid' },
    { label: 'Pending',     value: 'created' },
    { label: 'Failed',      value: 'failed' },
    { label: 'Refunded',    value: 'refunded' },
  ];
  pendingRows: any[] = [];
  showPending = false;

  // Per-school totals for a date range: one row per school, not per payment.
  fromDate: Date;
  toDate: Date;
  totalsRows: any[] = [];
  totalsGrand = 0;
  totalsSchools = 0;
  showTotals = false;
  loadingTotals = false;
  totalsError = '';
  selectedYear: any;
  selectedMonth: any;
  feeOptions: SelectItem[];
  feeType: string;
  paymentType: string;
  reportDataLength: number;
  constructor(
    private issoUtilService: IssoUtilService,
    private paymentInvoiceService: PaymentInvoiceService,
    private messageService: MessageService,
    private meritService: ReportMeritService
  ) {}

  ngOnInit() {
    this.reportLabel = "payment";
    this.reportValue = 0;
    this.yearOptions = this.issoUtilService.setYear();
    this.monthOptions = this.issoUtilService.setMonth();
    this.feeOptions = this.issoUtilService.setFeeType();
    this.feeType = "affilation";
    this.getPaymentData();
  }
  onPaymentTypeChange(event) {
    this.reportDataLength = 0;

    // this.mapStudentPaymentData = [];
    // this.slectedEvent = "";
    this.feeType = event.value;
    this.loadPaymentData();
    // this.totalAmount = 0;
    // console.log("affilateAmounnt===>" + this.totalAmount);
    // if (this.paymentType !== "") {
    //   if (
    //     this.paymentType == "affilation" ||
    //     this.paymentType == "kit" ||
    //     this.paymentType == "misc"
    //   ) {
    //     this.showPayment = true;
    //     this.isAffilated = "1";
    //     this.totalAmount = 0;
    //     this.affilateAmounnt = "";
    //   } else {
    //     this.showPayment = false;
    //     this.showAlredayPaidMessage = false;
    //     this.isAffilated = "2";
    //     this.loadEvents();
    //   }
    // } else {
    //   this.isAffilated = "0";
    // }
  }
  onloadMenu(index) {
    this.reportValue = index;
    if (index == "0") {
      this.isConsolited = false;
      this.reportLabel = "payment";
    } else if (index == "1") {
      this.reportLabel = "invoice";
    } else if (index == "2") {
      this.reportLabel = "receipt";
    } else if (index == "3") {
      this.reportLabel = "affilationfee";
    } else if (index == "4") {
      this.reportLabel = "sgfi";
    } else {
      this.reportLabel = "ifsSchool";
    }
  }
  getPaymentData() {
    const month = new Date().getMonth();
    const year = new Date().getFullYear();
    // var  m =  new Date().getMonth();
    // var y =  new Date().getFullYear();
    if (month >= 5) {
      this.yearvalue = year + "-" + (year + 1);
    } else {
      this.yearvalue = year - 1 + "-" + year;
    }
    //this.selectedMonth = m + '-' + y
    this.selectedYear = this.yearvalue;
    this.loadPaymentData();
  }
  onyeareChange(event) {
    this.yearvalue = event.value;
    this.selectedYear = this.yearvalue;
    this.loadPaymentData();
  }

  onMonthChange(event) {
    var m = (event.getMonth() + 1).toString().padStart(2, "0");
    var y = event.getFullYear().toString();
    // 2024-01-01 year month and date
    const filterMonthString = y + "-" + m + "-" + "01";

    this.paymentInvoiceService
      .getPaymentDataMonthWise(filterMonthString)
      .pipe(takeUntil(this.destroy$)).subscribe(
        (response) => {
          if (response !== "") {
            this.paymentData = response;
            if (this.paymentData.length > 0) {
              this.isDataAvailble = true;
            } else {
              this.isDataAvailble = false;
              this.messageService.add({
                key: "custom",
                severity: "error",
                summary: "Data not found for this year",
              });
            }
          } else {
          }
        },
        (error) => {
          //this.errorAlert =true;
        }
      );
  }
  exportAsXLSX() {
    this.meritService.exportAsExcelFile(this.paymentData, "paymentSheet");
  }
  private ymd(d: Date): string {
    const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }

  /** Totals per school between the two dates. Schools that paid nothing are omitted. */
  loadSchoolTotals() {
    if (!this.fromDate) { this.fromDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1); }
    if (!this.toDate)   { this.toDate = new Date(); }
    if (this.fromDate > this.toDate) {
      this.totalsError = 'The From date must be on or before the To date.';
      this.showTotals = true;
      return;
    }
    this.totalsError = '';
    this.loadingTotals = true;
    this.showTotals = true;

    this.paymentInvoiceService
      .getSchoolTotals(this.ymd(this.fromDate), this.ymd(this.toDate))
      .pipe(takeUntil(this.destroy$)).subscribe(
        (res: any) => {
          this.loadingTotals = false;
          this.totalsRows = res.rows || [];
          this.totalsGrand = res.grandTotal || 0;
          this.totalsSchools = res.schoolCount || 0;
        },
        (err: any) => {
          this.loadingTotals = false;
          this.totalsRows = []; this.totalsGrand = 0; this.totalsSchools = 0;
          this.totalsError = (err && err.error && err.error.error) || 'Could not load the totals.';
        },
      );
  }

  exportSchoolTotals() {
    if (!this.totalsRows.length) { return; }
    const sheet = this.totalsRows.map((r, i) => ({
      'Sr No.': i + 1,
      School: r.schoolName,
      'Total Paid': r.totalPaid,
      Payments: r.paymentCount,
      Students: r.studentCount,
      'Last Paid On': r.lastPaidOn ? new Date(r.lastPaidOn).toLocaleDateString() : '',
    }));
    this.meritService.exportAsExcelFile(sheet, 'school-payments-' + this.ymd(this.fromDate) + '-to-' + this.ymd(this.toDate));
  }

  applyStatusFilter() {
    this.paymentData = this.statusFilter === 'all'
      ? this.allPaymentData
      : this.allPaymentData.filter(r => (r.status || 'paid') === this.statusFilter);
  }

  onStatusFilterChange() {
    this.applyStatusFilter();
  }

  /** Payments opened over an hour ago and still unsettled. */
  loadPendingReconciliation() {
    this.paymentInvoiceService
      .getPendingReconciliation(this.yearvalue)
      .pipe(takeUntil(this.destroy$)).subscribe(
        (rows: any) => {
          this.pendingRows = rows || [];
          this.showPending = true;
        },
        () => { this.pendingRows = []; this.showPending = true; },
      );
  }

  statusLabel(row: any): string {
    const s = row && row.status ? row.status : 'paid';
    if (s === 'created')  { return 'Pending'; }
    if (s === 'failed')   { return 'Failed'; }
    if (s === 'refunded') { return 'Refunded'; }
    return 'Paid';
  }

  loadPaymentData() {
    this.paymentInvoiceService
      .getPaymentData(this.feeType, this.yearvalue)
      .pipe(takeUntil(this.destroy$)).subscribe(
        (response) => {
          if (response !== "") {
            //  const sortedData = response.sort((a, b) => b.payAmount - a.payAmount);
            this.allPaymentData = (response as any[]).sort(
              (a, b) => b.payAmount - a.payAmount
            );
            this.applyStatusFilter();

            if (this.paymentData.length > 0) {
              this.isDataAvailble = true;
            } else {
              this.isDataAvailble = false;
              this.messageService.add({
                key: "custom",
                severity: "error",
                summary: "Data not found for this year",
              });
            }
          } else {
          }
        },
        (error) => {
          //this.errorAlert =true;
        }
      );
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
